var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBracePending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 318 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 318,
    height: 313,
    fill: "#FAFAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.601 107.934C258.724 102.689 249.205 102.689 243.329 107.934L184.257 160.664L206.709 128.859C206.709 128.859 209.868 124.568 210.264 123.932C210.399 123.72 210.518 123.501 210.637 123.288C210.748 123.126 210.835 122.956 210.898 122.787C213.29 117.873 212.244 111.949 207.746 107.934C201.87 102.689 192.35 102.689 186.474 107.934L126.958 161.06L149.688 128.859C149.688 128.859 152.863 124.815 153.426 123.918C156.586 118.814 155.746 112.26 150.891 107.934C145.015 102.689 135.496 102.689 129.619 107.934L54.4072 175.071C48.5309 180.316 48.5309 188.813 54.4072 194.059C60.2836 199.304 69.8029 199.304 75.6792 194.059L135.219 140.912L113.139 172.194C113.139 172.194 109.417 177.015 108.886 177.828C108.514 178.4 108.189 178.987 107.92 179.595C107.825 179.765 107.746 179.935 107.698 180.118C105.845 184.834 107.033 190.291 111.254 194.066C117.13 199.311 126.65 199.311 132.526 194.066L192.517 140.516L170.152 172.201C170.152 172.201 166.374 176.852 165.733 177.835C162.391 182.974 163.183 189.669 168.109 194.066C173.985 199.311 183.504 199.311 189.381 194.066L264.593 126.929C270.469 121.684 270.469 113.187 264.593 107.941L264.601 107.934Z",
    fill: "#D8D9E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracePending);
export default __webpack_public_path__ + "static/media/brace-pending.aafcef70d752dcaf9c8afab274915c3e.svg";
export { ForwardRef as ReactComponent };